import { render, staticRenderFns } from "./LabelInDefaultSlot.vue?vue&type=template&id=59a62591"
import script from "./LabelInDefaultSlot.vue?vue&type=script&lang=js"
export * from "./LabelInDefaultSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports